import React, { useEffect, useRef, useState } from 'react';
import moment from 'moment';
import { TextInput } from 'react-native';
import { Text, View, createStyleSheet, useStyleSheet } from '@gopeerproject/ui-kit';
export const DateInput = ({ date, setDate, label, style }) => {
    const styles = useStyleSheet(getStyles);
    const dayRef = useRef(null);
    const monthRef = useRef(null);
    const yearRef = useRef(null);
    const [day, setDay] = useState(String(moment(date).date() + 1).padStart(2, '0'));
    const [month, setMonth] = useState(String(moment(date).month()).padStart(2, '0'));
    const [year, setYear] = useState(moment(date).year().toString());
    const setToDate = (date) => {
        if (date && moment(date).isValid()) {
            setDay(String(moment(date).date()).padStart(2, '0'));
            setMonth(String(moment(date).month() + 1).padStart(2, '0'));
            setYear(moment(date).year().toString());
        }
        else {
            setDay('');
            setMonth('');
            setYear('');
        }
    };
    useEffect(() => {
        setToDate(date);
    }, [date]);
    const onBlur = (e) => {
        if ([dayRef.current, monthRef.current, yearRef.current].includes(e.relatedTarget))
            return;
        const newDate = moment({
            year: parseInt(year),
            month: parseInt(month) - 1,
            day: parseInt(day)
        });
        if (newDate.isValid())
            setDate(newDate.toISOString());
        setToDate(newDate.isValid() ? newDate.toISOString() : date);
    };
    return (React.createElement(View, { style: styles.container },
        label && (React.createElement(Text, { type: 'body', style: styles.label, size: 'md', weight: 'semibold' }, label)),
        React.createElement(View, { style: [styles.wrapper, style] },
            React.createElement(TextInput, { onBlur: onBlur, style: styles.input, value: month, keyboardType: 'number-pad', onChangeText: setMonth, ref: monthRef, placeholder: 'MM' }),
            React.createElement(Text, { style: styles.text, type: 'body', size: 'lg', weight: 'regular' }, "/"),
            React.createElement(TextInput, { onBlur: onBlur, style: styles.input, value: day, onChangeText: setDay, keyboardType: 'number-pad', ref: dayRef, placeholder: 'DD' }),
            React.createElement(Text, { style: styles.text, type: 'body', size: 'lg', weight: 'regular' }, "/"),
            React.createElement(TextInput, { onBlur: onBlur, style: [styles.input, styles.input__year], value: year, keyboardType: 'number-pad', onChangeText: setYear, ref: yearRef, placeholder: 'Year' }))));
};
const getStyles = createStyleSheet(({ color, size }) => ({
    container: { flexGrow: 1 },
    wrapper: {
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: color.invert2.p4,
        padding: size.F,
        flexDirection: 'row',
        borderRadius: size.C,
        justifyContent: 'space-between',
        flexGrow: 1
    },
    input: {
        fontSize: size.G,
        height: size.G,
        width: size.L,
        color: color.invert2.p100,
        textAlign: 'center'
    },
    input__year: { width: size.M },
    text: { color: color.invert2.p16 },
    label: {
        marginBottom: size.C,
        marginTop: size.B,
        textAlign: 'center'
    }
}));
//# sourceMappingURL=DateInput.js.map